import React from 'react';
import { Link } from 'react-router-dom';
import {FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-section brand">
                    <Link to="/" className="footer-logo">
                        FIT<span className="text-green">Simplu</span>
                    </Link>
                    <p className="footer-desc">
                        Antrenamente personalizate pentru rezultate maxime.
                    </p>
                </div>

                <div className="footer-section links">
                    <h3>Link-uri Rapide</h3>
                    <ul>
                        <li><Link to="/">Acasă</Link></li>
                        <li><Link to="/plans">Planuri</Link></li>
                        <li><Link to="/about">Despre</Link></li>
                    </ul>
                </div>

                <div className="footer-section contact">
                    <h3>Contact Us</h3>
                    <div className="contact-info">
                        <p><strong>Email:</strong> fitsimplu@hadadecosmin.fit</p>
                        <p><strong>Telefon:</strong> +40 729 151 361</p>
                    </div>

                    <div className="social-icons">

                        <a href="https://www.instagram.com/hadadecosmin?igsh=MXZ3NnZ6MHplMXM4NQ==" target="_blank" rel="noreferrer" className="social-icon">
                            <FaInstagram />
                        </a>

                        <a href="https://www.facebook.com/share/17f6iprDCz/" target="_blank" rel="noreferrer" className="social-icon">
                            <FaFacebookF />
                        </a>

                        <a href="https://wa.me/40729151361" target="_blank" rel="noreferrer" className="social-icon">
                            <FaWhatsapp />
                        </a>
                        <a href="https://www.tiktok.com/@cosminhadade.16" target="_blank" rel="noreferrer" className="social-icon">
                            <FaTiktok />
                        </a>
                    </div>

                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; 2024 FitSimplu. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;